/**
 * This is a bundle of utilities
 * @class Types
 */
 import Cookies from './cookies';

 let Types = {
     /**
     * Write the message 'Message' on console as error if the condition is false; Returns true or false based on condition resolution
     * @function
     * @param {Function} Condition - The condition to be tested
     * @param {String} Message - The error message to show on console
     */
     Assert: function (Condition, Message) {
         if (Condition != true)
             console.error(Message);
 
         return (Condition == true);
     },
 
 
     /**
      * Convert a value to integer, if null sets it to 0 or else to the value passed as WhenNullVal
      * @function
      * @param {Any} Value - The value to be converter
      * @param {Any} WhenNullVal - The value to return if the the value is null
      */
     ToInt: function (Value, WhenNullVal) {
         if (WhenNullVal == null)
             WhenNullVal = 0;
         if (Value == null || Value == "")
             return WhenNullVal;
 
         return parseInt(Value);
     },
 
 
     /**
      * Convert a value to a string, if null sets it to "" or else to the value passed as WhenNullVal
      * @function
      * @param {Any} Value - The value to be converter
      * @param {Any} WhenNullVal - The value to return if the the value is null
      */
     ToString: function (Value, WhenNullVal) {
         if (WhenNullVal == null)
             WhenNullVal = "";
         if (Value == null)
             return WhenNullVal;
 
         return Value.toString();
     },
 
     /**
      * Convert a value to a float, if null sets it to 0 or else to the value passed as WhenNullVal
      * @function
      * @param {Any} Value - The value to be converter
      * @param {Any} WhenNullVal - The value to return if the the value is null
      */
     ToFloat: function (Value, WhenNullVal) {
         if (WhenNullVal == null)
             WhenNullVal = 0;
         if (Value == null)
             return WhenNullVal;
 
         return parseFloat(Value);
     },
 
 
     /**
      * Convert a value to a bool, if null sets it to false or else to the value passed as WhenNullVal
      * @function
      * @param {Any} Value - The value to be converter
      * @param {Any} WhenNullVal - The value to return if the the value is null
      */
     ToBool: function (Value, WhenNullVal) {
 
         if (WhenNullVal == null)
             WhenNullVal = false;
         if (Value == null)
             return WhenNullVal;
 
         if (Value === true)
             return true;
         if (Value === false)
             return false;
 
         if (typeof Value === 'string' && Value.toLowerCase() == 'true')
             return true;
 
         return (Types.ToInt(Value) > 0);
     },
 
     /**
      * Convert a value to a date, if null or not convertible sets it to a Date(1970,1,1) or else to the value passed as WhenNullVal
      * @function
      * @param {Any} Value - The value to be converter
      * @param {Any} WhenNullVal - The value to return if the the value is null
      */
     ToDate: function (Value, WhenNullVal) {
         // TK: STEFANO - CTBT-980 START
         if (typeof WhenNullVal == "undefined")
             WhenNullVal = new Date(1970, 1, 1);
 
         // Value is null or empty string
         if (!Value)
             return WhenNullVal;
 
         // Is already a date
         if (typeof Value.getMonth == "function")
             return Value;
 
         // Process date as string
         let StringDateUTC = Value.toString();
         let date = null;
         if (StringDateUTC != null) {
             let idxDot = StringDateUTC.indexOf(".");
             if (idxDot > 0)
                 StringDateUTC = StringDateUTC.substring(0, idxDot);
 
             StringDateUTC = StringDateUTC.replace(" ", "T");
             if (StringDateUTC.indexOf("Z") == -1)
                 StringDateUTC += "Z";
 
             date = new Date(StringDateUTC);
         }
         else {
             let sDateUTC = new Date().toISOString();
             date = new Date(sDateUTC);
         }
 
         if (date == null)
             return WhenNullVal;
 
         return date;
         // TK: STEFANO - CTBT-980 END
     },
 
     /**
      * Test if a date is empty
      * @function
      * @param {Date} date - The date to be tested
      */
     IsDateEmpty: function (date) {
         let dt = Types.ToDate(date);
 
         if (dt.getFullYear() == "0001" || dt.getFullYear() == "0000")
             return true;
 
         return false;
     },
 
 
     /**
      * Test if a parameter is of array type
      * @function
      * @param {Object} obj - The object to be tested
      */
     IsArray: function (obj) {
         return (obj != null && Array == obj.constructor);
     },
 
 
     /**
      * Given an object of unknown type (associative array) and a known type object, returns the object with the properties of the known <br />
      * type object valued with the corresponding values of the associative array.<br />
      * Return on console any possible type errors or missing types.
      * @function
      * @param {Object} UnknowObj - The object of unknow type
      * @param {Object} KnownObj - The object of known type
      */
     CheckObj: function (UnknowObj, KnownObj) {
 
         // Suppone il Unknown Obj come se fosse un array, poi se non lo è si regola in output
         let UnknowObjArray = UnknowObj;
         if (UnknowObjArray == null) {
             console.error("TypeHelper.CheckObj - UnknowObj is null");
             UnknowObjArray = [{}];
         }
         else if (Array.isArray(UnknowObj) == false)
             UnknowObjArray = [UnknowObjArray];
 
         if (KnownObj == null) {
             console.error("TypeHelper.CheckObj - KnownObj is null");
             return UnknowObj;
         }
 
         // Estrae tutte per properities dell'oggetto di partenza
         let Props = [];
         for (let PropName in KnownObj) {
             if (KnownObj.hasOwnProperty(PropName)) {
 
                 let Type = typeof (KnownObj[PropName]);
                 let toClass = {}.toString;
                 if (toClass.call(KnownObj[PropName]) == toClass.call(new Date))
                     Type = "date";
 
                 if ((["number", "string", "boolean", "object", "date"]).indexOf(Type) == -1)
                     console.error("TypeHelper.CheckObj - unsupported property type copied As Is - Property: " + PropName + " - Type: " + Type);
 
                 Props.push({ "PropName": PropName, "Type": Type });
             }
         }
 
         for (let i = 0; i < UnknowObjArray.length; i++) {
             let retObj = {};
 
             // Copia le proprietà enumerabili dell'oggetto sorgente in quello destinazione
             Object.assign(retObj, KnownObj);
 
             let MissingFields = [];
 
             // Inizializza clonando l'oggetto di partenza e prova ad assegnarne i valori
             for (let ip = 0; ip < Props.length; ip++) {
                 let KOPType = Props[ip].Type;
                 let PropName = Props[ip].PropName;
                 let UObj = UnknowObjArray[i];
 
                 if (UObj.hasOwnProperty(PropName)) {
                     switch (KOPType) {
                         case "number":
                             UObj[PropName] = Types.ToFloat(UObj[PropName], KnownObj[PropName]);
                             break;
                         case "string":
                             UObj[PropName] = Types.ToString(UObj[PropName], KnownObj[PropName]);
                             break;
                         case "boolean":
                             UObj[PropName] = Types.ToBool(UObj[PropName], KnownObj[PropName]);
                             break;
                         case "date":
                             UObj[PropName] = Types.ToDate(UObj[PropName], KnownObj[PropName]);
                             break;
                         case "object":
                             UObj[PropName] = Types.CheckObj(UObj[PropName], KnownObj[PropName]);
                             console.error("TypeHelper.CheckObj - object type: " + PropName);
                             break;
                         default:
                             UObj[PropName] = UObj[PropName];
                             break;
                     }
 
                 }
                 else
                     MissingFields.push(PropName);
             }
             if (MissingFields.length > 0)
                 console.error("TypeHelper.CheckObj - UnknowObj[" + i + "] misses properties: " + MissingFields.join());
         }
 
         return UnknowObj;
     },
 
 
     /**
      * Given an object, it lets you manage its properties with getters and setters<br />
      * When a property is called with the getter, its handler is invoked and the value could change<br />
      * Getter handler is a function defined on the object with name "OnGet_<PROPERTY_NAME>"<br />
      * When a value is changed via setter, the Setted handler is invoked with NewVal and OldVal parameters<br />
      * Setted handler is function defined on the object with name "OnSetted_<PROPERTY_NAME>"<br />
      * Properties are redefined in internal variables of __OrigProperties property
      * @function
      * @param {Object} oObject - The object which properties will be managed
      */
     HandlerizeObject: function (oObject) {
         if (oObject["__OrigProperties"] == null)
             oObject["__OrigProperties"] = {};
 
         Object.keys(oObject).forEach(function (Key, index) {
             if (Key == "__OrigProperties")
                 return;
 
             let isFunction = !!(Key && Key.constructor && Key.call && Key.apply);
             if (isFunction)
                 return;
 
             if (oObject["OnGet_" + Key] != null || oObject["OnSet_" + Key] != null || oObject["OnSetted_" + Key] != null) {
                 oObject["__OrigProperties"][Key] = oObject[Key];
 
                 Object.defineProperty(oObject, Key, {
                     get: function () {
                         let fn = oObject["OnGet_" + Key];
                         if (fn != null) {
                             let ret = null;
                             try {
                                 ret = fn(oObject["__OrigProperties"][Key]);
                             }
                             catch (e) { };
 
                             if (typeof ret === 'undefined')
                                 ret = oObject["__OrigProperties"][Key];
 
                             return ret;
                         }
                         return oObject["__OrigProperties"][Key];
                     },
                     set: function (NewVal) {
                         let OldVal = oObject["__OrigProperties"][Key];
                         let fn = oObject["OnSet_" + Key];
                         if (fn != null) {
                             let ret;
                             try {
                                 ret = fn(NewVal, OldVal);
                             }
                             catch (e) { };
 
                             if (typeof ret !== 'undefined')
                                 NewVal = ret;
                         }
 
                         oObject["__OrigProperties"][Key] = NewVal;
 
                         let fnComplete = oObject["OnSetted_" + Key];
                         if (fnComplete != null) {
                             try {
                                 fnComplete(NewVal, OldVal);
                             }
                             catch (e) { };
                         }
                     }
                 });
             }
         });
     },
 
     /**
      * TimeStamp utilities. It includes: <br />
      * Now: actual timestampg <br />
      * Get(StringDateUTC): the timestamp of the given date string <br />
      * GetTime(StringDateUTC): returns the time of the given date stringg <br />
      * Format(date, FormatString): formats the given date with the specified format stringg <br />
      * PrettifyRelative(iTimeStamp): Add labels to days, weeks, months, years, minutes and seconds to the given timestampg <br />
      * PrettifyShort(iTimeStamp): Returns the given timestamp in DD/MM/YYYY HH:SS format
      * @function
      */
     Timestamp: {
 
         /**
          * Language translation object, use Ln.Ts(string) to get the word translation in the selected language (from cookie)
          * @function
          */
         Ln: {
             "default": {
                 // Lingua di default inglese ritorna la stringa passata
             },
             "it": {
                 'now': 'adesso',
                 'min': 'min',
                 'hours': 'ore',
                 'hour': 'ora',
                 'days': 'giorni',
                 'day': 'giorno',
                 'weeks': 'settimane',
                 'week': 'settimana',
                 'months': 'mesi',
                 'month': 'mese',
                 'years': 'anni',
                 'year': 'anno',
                 'Today': 'Oggi',
                 'Yesterday': 'Ieri',
             },
             "fu": {
                 'now': 'cumò',
                 'min': 'min',
                 'hours': 'oris',
                 'hour': 'ore',
                 'days': 'dîs',
                 'day': 'dì',
                 'weeks': 'stemanis',
                 'week': 'stemane',
                 'months': 'mês',
                 'month': 'mês',
                 'years': 'agns',
                 'year': 'an',
                 'Today': 'vuê',
                 'Yesterday': 'îr',
             },
             "de": {
                 'now': 'jetzt',
                 'min': 'Min',
                 'hours': 'Stunden',
                 'hour': 'Stunde',
                 'days': 'Tage',
                 'day': 'Tag',
                 'weeks': 'Wochen',
                 'week': 'Woche',
                 'months': 'Monate',
                 'month': 'Monat',
                 'years': 'Jahre',
                 'year': 'Jahr',
                 'Today': 'Heute',
                 'Yesterday': 'Gestern',
             },
             "fr": {
                 'now': 'maintenant',
                 'min': 'min',
                 'hours': 'heures',
                 'hour': 'heure',
                 'days': 'jours',
                 'day': 'jour',
                 'weeks': 'semaines',
                 'week': 'semaine',
                 'months': 'mois',
                 'month': 'mois',
                 'years': 'ans',
                 'year': 'année',
                 'Today': 'Aujourd\'hui',
                 'Yesterday': 'Hier',
             },
             "ru": {
                 'now': 'сейчас',
                 'min': 'мин',
                 'hours': 'часы',
                 'hour': 'час',
                 'days': 'дней',
                 'day': 'день',
                 'weeks': 'недели',
                 'week': 'неделю',
                 'months': 'месяцы',
                 'month': 'месяц',
                 'years': 'годы',
                 'year': 'год',
                 'Today': 'Сегодня',
                 'Yesterday': 'Вчерашний день',
             },
             "es": {
                 'now': 'ahora',
                 'min': 'min',
                 'hours': 'horas',
                 'hour': 'hora',
                 'days': 'días',
                 'day': 'día',
                 'weeks': 'semanas',
                 'week': 'semana',
                 'months': 'meses',
                 'month': 'mes',
                 'years': 'años',
                 'year': 'año',
                 'Today': 'Hoy',
                 'Yesterday': 'Ayer',
             },
             "ro": {
                 'now': 'acum',
                 'min': 'min',
                 'hours': 'ore',
                 'hour': 'oră',
                 'days': 'zile',
                 'day': 'zi',
                 'weeks': 'săptămâni',
                 'week': 'săptămână',
                 'months': 'luni',
                 'month': 'lună',
                 'years': 'ani',
                 'year': 'an',
                 'Today': 'Astăzi',
                 'Yesterday': 'Ieri',
             },
 
 
             Ts: function (str) {
                 try {
                     let lang = Cookies.Get("lang");
                     if (Types.ToString(lang) == "") {
                         lang = Cookies.Get("Lang");
                         if (Types.ToString(lang) == "")
                             lang = navigator.language || navigator.userLanguage;
 
                         lang = lang.substr(0, 2).toLocaleLowerCase();
                     }
                     if (Types.Timestamp.Ln[lang] == null || Types.Timestamp.Ln[lang][str] == null)
                         return str;
 
                     return Types.Timestamp.Ln[lang][str];
                 }
                 catch (error) {
                     console.error(error);
                 }
 
                 return str;
             }
         },
 
         Now: function () {
             let sDateUTC = new Date().toISOString();
             return new Date(sDateUTC);
         },
 
         Get: function (StringDateUTC) {
             if (StringDateUTC != null) {
 
                 let idxDot = StringDateUTC.indexOf(".");
                 if (idxDot > 0)
                     StringDateUTC = StringDateUTC.substring(0, idxDot);
 
                 StringDateUTC = StringDateUTC.replace(" ", "T");
                 if (StringDateUTC.indexOf("Z") == -1)
                     StringDateUTC += "Z";
 
                 return new Date(StringDateUTC);
             }
 
             let sDateUTC = new Date().toISOString();
             return new Date(sDateUTC);
         },
 
         GetTime: function (StringDateUTC) {
             if (StringDateUTC != null) {
                 let minutes = StringDateUTC.getMinutes();
                 if (minutes < 10)
                     minutes = "0" + minutes;
                 let seconds = StringDateUTC.getSeconds();
                 if (seconds < 10)
                     seconds = "0" + seconds;
                 let hours = StringDateUTC.getHours();
                 if (hours < 10)
                     hours = "0" + hours;
                 return hours + ':' + minutes + ':' + seconds;
             }
 
             return '-:-:-';
         },
 
         Format: function (date, FormatString) {
             if (FormatString == null)
                 FormatString = 'YYYY-MM-DD HH:mm:ss';
 
             let d = new Date(date);
             FormatString = FormatString.replace("YYYY", ("0000" + d.getFullYear()).substr(-4, 4));
             FormatString = FormatString.replace("YYY", ("0000" + d.getFullYear()).substr(-3, 3));
             FormatString = FormatString.replace("YY", ("0000" + d.getFullYear()).substr(-2, 2));
             FormatString = FormatString.replace("MM", ("00" + (d.getMonth() + 1)).substr(-2, 2));
             FormatString = FormatString.replace("DD", ("00" + (d.getDate())).substr(-2, 2));
             FormatString = FormatString.replace("HH", ("00" + d.getHours()).substr(-2, 2));
             FormatString = FormatString.replace("mm", ("00" + d.getMinutes()).substr(-2, 2));
             FormatString = FormatString.replace("ss", ("00" + d.getSeconds()).substr(-2, 2));
 
             return FormatString;
         },
 
         Prettify: function (iTimeStamp, RelativeTime, ShortDate) {
             let date = Types.ToDate(iTimeStamp),
                 now = Types.Timestamp.Now(),
                 interval = now - date,
                 dateString = date,
                 second = 1000,
                 minute = second * 60,
                 hour = minute * 60,
                 day = hour * 24,
                 week = day * 7,
                 month = week * 4,
                 year = month * 12,
                 val = 0;
 
             if (Types.ToBool(RelativeTime) == true) {
                 if (interval < minute) {
                     dateString = Types.Timestamp.Ln.Ts('now')
                 } else if (interval < hour) {
                     val = Math.floor(interval / minute);
                     dateString = val.toString() + ' ' + (val > 1 ? Types.Timestamp.Ln.Ts('min') : Types.Timestamp.Ln.Ts('min'))
                 } else if (interval < day) {
                     val = Math.floor(interval / hour);
                     dateString = val.toString() + ' ' + (val > 1 ? Types.Timestamp.Ln.Ts('hours') : Types.Timestamp.Ln.Ts('hour'))
                 } else if (interval < week) {
                     val = Math.floor(interval / day)
                     dateString = val.toString() + ' ' + (val > 1 ? Types.Timestamp.Ln.Ts('days') : Types.Timestamp.Ln.Ts('day'))
                 } else if (interval < month) {
                     val = Math.floor(interval / week)
                     dateString = val.toString() + ' ' + (val > 1 ? Types.Timestamp.Ln.Ts('weeks') : Types.Timestamp.Ln.Ts('week'))
                 } else if (interval < year) {
                     val = Math.floor(interval / month)
                     dateString = val.toString() + ' ' + (val > 1 ? Types.Timestamp.Ln.Ts('months') : Types.Timestamp.Ln.Ts('month'))
                 } else {
                     val = Math.floor(interval / year)
                     dateString = val.toString() + ' ' + (val > 1 ? Types.Timestamp.Ln.Ts('years') : Types.Timestamp.Ln.Ts('year'))
                 }
                 return dateString
             }
             else {
                 let CurrentDate = Types.Timestamp.Ln.Ts("Today") + ", " + Types.Timestamp.Format(date, 'HH:mm');
 
                 if (date.getDate() == Types.Timestamp.Now().getDate() - 1 && date.getMonth() == Types.Timestamp.Now().getMonth())
                     CurrentDate = Types.Timestamp.Ln.Ts("Yesterday") + ", " + Types.Timestamp.Format(date, 'HH:mm');
                 else if (date.getDate() != Types.Timestamp.Now().getDate()) {
                     CurrentDate = Types.Timestamp.Format(date, 'DD/MM/YYYY');
                     if (Types.ToBool(ShortDate) == false)
                         CurrentDate += ', ' + Types.Timestamp.Format(date, 'HH:mm');
                 }
                 if (date.getDate() == Types.Timestamp.Now().getDate() && date.getMonth() != Types.Timestamp.Now().getMonth()) {
                     CurrentDate = Types.Timestamp.Format(date, 'DD/MM/YYYY');
                     if (Types.ToBool(ShortDate) == false)
                         CurrentDate += ', ' + Types.Timestamp.Format(date, 'HH:mm');
                 }
                 return CurrentDate;
             }
         },
 
         PrettifyRelative: function (iTimeStamp) { return Types.Timestamp.Prettify(iTimeStamp, true); },
         PrettifyShort: function (iTimeStamp) { return Types.Timestamp.Prettify(iTimeStamp, false, true); },
     },
 
 };
 
 window.Types = Types;
 export default Types;
 